export const SERVER_TIMEZONE = 'America/New_York'

export interface ProductIdLookupObj {
  [key: number]: string
}

export const PRODUCT_ID_LOOKUP: ProductIdLookupObj = {
  4102: 'MMA',
  4107: 'OSA',
  4108: 'HYSA',
}

export interface AccountTypeLookupObj {
  [key: string]: string
}

export const INVEST_ACCOUNT_TYPES = ['INVW', 'INVA', 'INVS']

export const INVEST_ACCOUNT_TYPES_MAP: AccountTypeLookupObj = {
  INVW: 'Wealth Management',
  INVA: 'Robo Portfolio',
  INVS: 'Self-Directed',
}

export const BANK_ACCOUNT_TYPES = ['CHECKING', 'SAVINGS', 'CD', 'IRA']

export const BANK_ACCOUNT_TYPES_MAP: AccountTypeLookupObj = {
  CHECKING: 'Interest Checking',
  SAVINGS: 'Savings',
  CD: 'CDs',
  IRA: 'IRAs',
}

export const STALE_DATA_COPY =
  'We can’t update your account information right now, but we’re working on it.'
